
import certificate from '../components/certificate/index2.vue'
import dispoitStep from '../components/dispoit-step.vue'
import dispointHeader from '../components/dispoint-header.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import  { common, commonApi, check, filter }  from '@/common/index';
import {mapState,mapActions} from 'vuex';
import getPayInfoMX from '../mixins/getPayInfo.js'
import publicMX from '../../mixins/publicMX.js'
import { parseTime } from '@/common/utils/Date.js'
import html2canvas from 'html2canvas';
import { validataNumber, ValidateRequire } from '@/common/utils/validate.js'
import { toStarString } from '@/common/utils/index.js'
export default {
directives: { TransferDom },
components: { XButton, Group, XInput, Confirm ,dispoitStep,certificate,dispointHeader, Qrcode },
mixins: [getPayInfoMX, publicMX],
filters: {
timeFilter(v) {
return parseTime(v)
},
moneyFormat(num) {
return filter.moneyFilter(num);
},
getTimeMS_(str) {
return filter.getTimeMS(str);
},
bankNumberFilters(str) {
return filter.INbankNumber(str);
},
},
data() {
return {
deposit: { imgUrl: '', amount: '', utr: '' },
imgUrl: ''
}
},
created() {

},
computed: {
qrCode() {
if (!this.paySelected.qrCode) {
return null
} else {
return this.$store.state.linkList.staticDomain + this.paySelected.qrCode
}
}
},
methods: {
checkSubmit2() { // 验证是否可以提交
const { amount, utr } = this.deposit
const { depositMin, depositMax } = this.paySelected
if (!validataNumber(amount) || (validataNumber(amount) && (amount * 1 > depositMax || amount * 1 < depositMin))) {
this.$vux.toast.show({ text: this.$t('Deposit').saveMoneyNumPlace + `${depositMin} ~ ${depositMax}`, type: 'cancel' })
return
}
if (!/^[A-Za-z0-9]{12}$/.test(utr)) {
this.$vux.toast.show({ text: 'UTR must be 12 digits or letters', type: 'cancel' })
return
}




return true
},
handeNext2() {
if (!this.checkSubmit2()) return
const params = { ...this.deposit, payId: this.paySelected.id, payerName:this.$store.state.userInfo.userInfo.name, deviceSource: 2, utr: this.deposit.utr}
this.submitLoading = true
this._submitDeposit2(params).then(res => {
this.submitLoading = false
this.orderInfo = res.order
if (this.paySelected.probability === 0) {

if (this.payParams.parentCode === 'SEMI_AUTOMATIC_ELECTRON') {
this.orderInfo.bankAccount = toStarString(this.orderInfo.bankAccount, true)
} else {
this.orderInfo.bankAccount = toStarString(this.orderInfo.bankAccount, undefined, 1)
}
}
this.step++
setTimeout(()=>{
this.buildImg();
}, 1000)
}).catch(err => {
this.$vux.toast.show({ text: err, type: 'warn' })
this.submitLoading = false
})
},
_submitDeposit2(param) { // 提交存款内容
return new Promise((resolve, reject) =>{
const params = Object.assign({}, { UUID: this.$store.state.UUID }, param)
commonApi.PAY.semiAutomaticPayOrder(params).then(data => {
resolve(data)
}).catch(err => {
reject(err)
})
})
},
buildImg(callback) {
html2canvas(document.querySelector("#depositSummaryDataDetail"), {useCORS: true}).then(canvas => {
const imgUrl = canvas.toDataURL("image/png");
this.imgUrl = imgUrl;
if (callback && typeof callback === 'function') {
callback();
}
});
},
cb() {
if (this.loadingInstance) {
this.loadingInstance.close();
}
setTimeout(()=>{
document.querySelector('#downloadBtn').click()
}, 10);
},
downloadImg() {
this.loadingInstance = this.$loading({});
this.buildImg(this.cb);
},
}
}



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/otherTransfer/index2.vue